import React from 'react';
import classNames from 'classnames';
import Base from 'antd/es/typography/Base';
import warning from 'antd/es/_util/warning';
import { ConfigContext } from '../config-provider';
import { tupleNum } from 'antd/es/_util/type';
import AntdConfigProvider from 'antd/es/config-provider';
const PARAGRAPH_LEVEL_LIST = tupleNum(1, 2, 3);
const Paragraph = (props) => {
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const { level = 1, className: customizeClassName, prefixCls: customizePrefixCls, category = 'body', ...otherProps } = props;
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    if (PARAGRAPH_LEVEL_LIST.indexOf(level) === -1) {
        if (process.env.NODE_ENV !== 'production')
            warning(false, 'Typography.Paragraph', 'Paragraph only accept `1 | 2 | 3');
    }
    if (category !== 'body' && level !== 1) {
        warning(false, 'Typography.Paragraph', 'Paragraph category other than `body` does not accept level paramter ');
    }
    if (!['body', 'button', 'caption', 'overline'].includes(category)) {
        warning(false, 'Typograph.Paragraph', 'Paragraph `category` only accepts `body | button | caption | overline`');
    }
    const className = classNames({
        [`${prefixCls}-${category}`]: category !== 'body',
        [`${prefixCls}-paragraph-${level}`]: category === 'body'
    }, customizeClassName);
    return (React.createElement(AntdConfigProvider, { ...restContext, prefixCls: getPrefixCls('', customizePrefixCls) },
        React.createElement(Base, { ...otherProps, className: className, component: 'div', prefixCls: prefixCls })));
};
export default Paragraph;
